import { differenceInCalendarDays, format } from 'date-fns';
import { fromDateStampObject, timestampToUTCDatestampObject, toDate } from './translator';
export const timeTextsPath = 'common.time';
export function formatDate(datestamp) {
    let { long } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const date = typeof datestamp === 'number' || typeof datestamp === 'string' ? fromDateStampObject(timestampToUTCDatestampObject(new Date(datestamp).getTime())) : datestamp instanceof Date ? datestamp : toDate(datestamp);
    return long ? format(date, 'PP') : date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
    });
}
export function formatDateLong(datestamp) {
    return formatDate(datestamp, {
        long: true
    });
}
export function formatDateWithTime(datestamp) {
    let withTimezone = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const date = datestamp instanceof Date ? datestamp : toDate(datestamp);
    return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        timeZoneName: withTimezone ? 'short' : undefined
    });
}
export function formatDateWithTimeShortMonth(datestamp) {
    let withTimezone = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const date = datestamp instanceof Date ? datestamp : toDate(datestamp);
    return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
        timeZoneName: withTimezone ? 'short' : undefined
    });
}
const relativeTimeFormatter = new Intl.RelativeTimeFormat('en', {
    numeric: 'auto'
});
export function formatDaysUntil(timestamp) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Date();
    const diff = timestamp > now.getTime() ? differenceInCalendarDays(timestamp, now) : 0;
    return relativeTimeFormatter.format(diff, 'day');
}
const twoMinutes = 1000 * 60 * 2;
const oneHourMs = 1000 * 60 * 60;
const oneDayMs = oneHourMs * 24;
const twoWeeks = oneDayMs * 14;
export function formatTimeAgo(timestamp, texts) {
    const now = Date.now();
    const timePassed = now - timestamp;
    if (timePassed <= twoMinutes) {
        return texts.justNow();
    } else if (timePassed >= twoWeeks) {
        return formatDate(timestamp);
    } else if (timePassed < oneHourMs) {
        const count = Math.floor(timePassed / (1000 * 60));
        return texts.minutesAgo({
            count
        });
    } else if (timePassed < oneDayMs) {
        const count = Math.round(timePassed / oneHourMs);
        return texts.hoursAgo({
            count
        });
    } else {
        const count = Math.floor(timePassed / oneDayMs);
        return texts.daysAgo({
            count
        });
    }
}
export const formatDuration = (param)=>{
    let { hours, minutes, texts } = param;
    return texts.duration({
        hours: hours !== null && hours !== void 0 ? hours : 0,
        minutes
    });
};
